import { render, staticRenderFns } from "./CommAccidents.vue?vue&type=template&id=c2370e00&scoped=true"
import script from "./CommAccidents.vue?vue&type=script&lang=js"
export * from "./CommAccidents.vue?vue&type=script&lang=js"
import style0 from "./CommAccidents.vue?vue&type=style&index=0&id=c2370e00&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2370e00",
  null
  
)

export default component.exports